import React, { useEffect, useState } from 'react'
import { BsHeadset, BsEnvelope } from "react-icons/bs";
import { FiPhone } from "react-icons/fi";
import { RiCheckboxCircleLine } from "react-icons/ri";
import ser1 from "../../assets/ser-1.png"
import ser2 from "../../assets/ser2.jpeg"
import ser3 from "../../assets/ser3.png"
import ser4 from "../../assets/ser4.jpeg"
import ser5 from "../../assets/ser5.jpeg"
import ser6 from "../../assets/ser6.png"


const ServiceBody = () => {
    const [edu, setEdu] = useState(true);
    const [exam, setExam] = useState(false);
    const [cbt, setCbt] = useState(false);
    const [tutorial, setTutorial] = useState(false);
    const [study, setStudy] = useState(false);
    const [foreign, setForeign] = useState(false);

    const handleClickEducation = () => {
        setEdu(true)
        setExam(false)
        setForeign(false)
        setCbt(false)
        setStudy(false)
        setTutorial(false)
        
    }
    const handleClickExam = () => {
        setEdu(false)
        setExam(true)
        setForeign(false)
        setCbt(false)
        setStudy(false)
        setTutorial(false)
    }
    const handleClickCbt = () => {
        setEdu(false)
        setExam(false)
        setCbt(true)
        setForeign(false)
        setStudy(false)
        setTutorial(false)
    }
    const handleClickTutorial = () => {
        setEdu(false)
        setExam(false)
        setTutorial(true)
        setForeign(false)
        setCbt(false)
        setStudy(false)
        
    }
    const handleClickStudy = () => {
        setEdu(false)
        setExam(false)
        setStudy(true)
        setForeign(false)
        setCbt(false)
        setTutorial(false)
    }
    const handleClickForeign = () => {
        setEdu(false)
        setExam(false)
        setForeign(true)
        setCbt(false)
        setStudy(false)
        setTutorial(false)
    }
    return (
    <section className='mb-0 pt-[80px] md:pt-[70px]'>
        <h2 className='text-center text-4xl text-[#4B4B4B] font-semibold mt-10'>Explore our range of Services Here</h2>
        <p className='text-[#5E5E5E] text-base font-normal text-center mb-10 mt-5'>
        Discover the Multifaceted Services Available Here to Cater to Your Educational Requirements

        </p>
        <section className='flex md:flex-col md:w-[90%] justify-between w-[80%] mx-auto'>
            <div className='w-[30%] md:w-full md:mb-9'>
                <section className='p-6 sm:p-3 w-full rounded-tr-2xl rounded-tl-2xl' style={{border: '1px dashed #766DC5', borderBottom: 0}}>
                    <h2 className='text-[#454242] font-semibold text-2xl '>Services List</h2>
                    <ul  className='mt-4'>
                        <li className={edu === true ? "bg-[#5146AE] py-4 px-4 mb-2" : "bg-[#F6F6F7]  py-4 px-4 mb-2"} onClick={handleClickEducation}>
                            <span className={edu === true ? "text-white" : "text-[#4A4747]"} >Education Consultancy</span>
                        </li>
                        <li className={exam === true ? "bg-[#5146AE] py-4 px-4 mb-2" : "bg-[#F6F6F7]  py-4 px-4 mb-2"}  onClick={handleClickExam}>
                            <span className={exam === true ? "text-white" : "text-[#4A4747]"} >Exam Registrations</span>
                        </li>
                        <li className={cbt === true ? "bg-[#5146AE] py-4 px-4 mb-2" : "bg-[#F6F6F7]  py-4 px-4 mb-2"}  onClick={handleClickCbt}>
                            <span className={cbt === true ? "text-white" : "text-[#4A4747]"} >CBT</span>
                        </li>
                        <li className={tutorial === true ? "bg-[#5146AE] py-4 px-4 mb-2" : "bg-[#F6F6F7]  py-4 px-4 mb-2"}  onClick={handleClickTutorial}>
                            <span className={tutorial === true ? "text-white" : "text-[#4A4747]"}>Tutorial Services</span>
                        </li>
                        <li className={study === true ? "bg-[#5146AE] py-4 px-4 mb-2" : "bg-[#F6F6F7]  py-4 px-4 mb-2"}  onClick={handleClickStudy}>
                            <span className={study === true ? "text-white" : "text-[#4A4747]"}>Study Abroad</span>
                        </li>
                        <li  className={foreign === true ? "bg-[#5146AE] py-4 px-4 mb-2" : "bg-[#F6F6F7]  py-4 px-4 mb-2"}  onClick={handleClickForeign}>
                            <span className={foreign === true ? "text-white" : "text-[#4A4747]"}>Quest Tech Empowerment</span>
                        </li>
                    </ul>
                </section>
                <section className='bg-[#5146AE] py-8 flex flex-col justify-center items-center mt-0'>
                    <BsHeadset color='white' className='w-[56px] h-[56px]'  />
                    <h2 className='text-white text-2xl font-medium  text-center mt-2'>Have a Question?</h2>
                    <div className='flex  mt-7 mb-3'>
                        <FiPhone className='w-[18px] h-[18px] my-auto mr-4' color='white' /> <span className='font-medium text-base my-auto text-white'>+234 8155 0400 74</span>
                    </div>
                    <div className='flex mb-3'>
                        <BsEnvelope className='w-[18px] h-[18px] mr-4 my-auto' color='white' /> <span className='font-medium text-base my-auto text-white'>quest@yahoo.com</span>
                    </div>
                </section>
            </div>
            <div className='w-[60%]  md:w-full'>
                <div className={edu === true ? "block w-full" : "hidden"}>
                    <img src={ser1} alt="edu" className='w-full object-cover h-[440px] md:h-[254px]' />
                    <h2 className='text-[#3F3C3C] font-semibold text-[30px] my-8'>Education Consultancy</h2>
                    <p className='text-[#625F5F] text-base font-normal mb-4 leading-[25px]'>
                    We offer comprehensive education consultancy services to support students, educators, and institutions alike. Our experienced consultants provide personalized guidance and innovative solutions to address various educational needs and challenges. From academic planning and curriculum development to strategic initiatives and beyond, we collaborate closely with our clients to ensure their goals are achieved effectively and efficiently. With a commitment to excellence and a passion for education, we strive to empower individuals and institutions to reach their full potential.
                    </p>
                    <div className='flex gap-[10px] justify-between mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base w-[95%] md:w-[100%] '>
                        Our consultancy services are customized to meet the unique needs of each client, ensuring personalized support and successful outcomes.
                        </p>
                    </div>
                    <div className='flex gap-[10px] justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%] md:w-[100%] '>
                        We foster continuous collaboration with clients, providing ongoing support and guidiance.
                        </p>
                    </div>
                    <div className='flex gap-[10px] justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%] md:w-[100%] '>
                        We strive to make a positive impact on the educational landscape, empowering individuals and institutions to thrive.
                        </p>
                    </div>
                    <p className='text-[#625F5F] text-base font-normal leading-[25px]'>
                    At Quest-Inspire, our commitment to transforming education is evident in our comprehensive consultancy services. With personalized guidance, ongoing collaboration, and impactful partnerships, we empower individuals and institutions to achieve their educational goals effectively. Join us as we continue to make a meaningful difference in education, one consultation at a time
                    </p>
                </div>
                <div className={exam === true ? "block w-full" : "hidden"}>
                    <img src={ser2} alt="edu" className='w-full object-cover h-[440px] md:h-[254px]' />
                    <h2 className='text-[#3F3C3C] font-semibold text-[30px] my-8'>Exam Registrations</h2>
                    <p className='text-[#625F5F] text-base font-normal mb-4 leading-[25px]'>
                    At Quest-Inspire, we offer a comprehensive range of exam registration services to cater to both local and international academic requirements. From essential Nigerian examinations like JAMB, WAEC, NECO, and IJMB to internationally recognized tests such as TOEFL, GRE, and SAT, we ensure that you have the necessary support to register for the exams that matter to you. Our experienced team is well-versed in the registration processes for various exams, ensuring that you navigate through them smoothly and efficiently." below are some of the key benefits and features of our exam registration service.
                    </p>
                    <div className='flex gap-[10px] justify-between mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base w-[95%]  md:w-[100%] '>
                        We register for local (JAMB, WAEC, NECO, IJMB) and international exams (TOEFL, GRE, SAT), ensuring comprehensive coverage for all academic pursuits.
                        </p>
                    </div>
                    <div className='flex gap-[10px] justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%]  md:w-[100%] '>
                        Our experienced team provides expert guidance and support throughout the registration process, ensuring accurate and timely completion.
                        </p>
                    </div>
                    <div className='flex gap-[10px] justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%]  md:w-[100%] '>
                        We prioritize efficiency and effectiveness in our registration process, ensuring a stress-free experience for you to focus on exam preparation.
                        </p>
                    </div>
                    <p className='text-[#625F5F] text-base font-normal leading-[25px]'>
                    With our comprehensive range of exam registration services, expert guidance, and seamless process, Quest-Inspire is your trusted partner in navigating the complexities of exam registration, ensuring that you have the necessary support to register for the exams that matter to you.
                    </p>
                </div>
                <div className={cbt === true ? "block w-full" : "hidden"}>
                    <img src={ser3} alt="edu" className='w-full object-cover h-[440px] md:h-[254px]' />
                    <h2 className='text-[#3F3C3C] font-semibold text-[30px] my-8'>computer Based Test(CBT) Training</h2>
                    <p className='text-[#625F5F] text-base font-normal mb-4 leading-[25px]'>
                    At Quest-Inspire, we provide comprehensive Computer-Based Test (CBT) training to prepare students for various standardized exams. Our CBT training program covers essential skills such as test-taking strategies, time management techniques, and familiarization with CBT interfaces. With hands-on practice sessions and expert guidance from our experienced instructors, students gain confidence and proficiency in navigating CBT exams effectively. Whether you're preparing for entrance exams, professional certifications, or standardized tests, our CBT training equips you with the tools you need to succeed. Join us at Quest-Inspire and excel in your CBT exams with confidence."
                    </p>
                    <div className='flex gap-[10px] justify-between mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base w-[95%]  md:w-[100%] '>
                        We register for local (JAMB, WAEC, NECO, IJMB) and international exams (TOEFL, GRE, SAT), ensuring comprehensive coverage for all academic pursuits.
                        </p>
                    </div>
                    <div className='flex  gap-[10px]  justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%]  md:w-[100%] '>
                        Our CBT training program is designed to cover all aspects of CBT exams, ensuring that students are well-prepared for the challenges they may encounter.
                        </p>
                    </div>
                    <div className='flex  gap-[10px]  justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%]  md:w-[100%] '>
                        We offer expert guidance and support throughout the training process, providing personalized assistance to address individual learning needs and ensure student success.
                        </p>
                    </div>
                    <p className='text-[#625F5F] text-base font-normal leading-[25px]'>
                    Join us at Quest-Inspire and embark on a journey to excel in your CBT exams with confidence. With our comprehensive curriculum, hands-on practice, and expert guidance, we are dedicated to helping you achieve your academic and professional goals.
                    </p>
                </div>
                <div className={tutorial === true ? "block w-full" : "hidden"}>
                    <img src={ser4} alt="edu" className='w-full object-cover h-[440px] md:h-[254px]' />
                    <h2 className='text-[#3F3C3C] font-semibold text-[30px] my-8'>Tutorial Services</h2>
                    <p className='text-[#625F5F] text-base font-normal mb-4 leading-[25px]'>
                    At Quest-Inspire, we understand that every student has unique learning preferences. That's why we offer both private and classroom lectures to cater to individual needs. Our private lectures provide personalized attention, allowing students to focus on specific areas of improvement and progress at their own pace. On the other hand, our classroom lectures foster collaboration and interaction among peers, creating a dynamic learning environment. Whether you prefer one-on-one instruction or group learning, Quest-Inspire provides flexible options to suit your learning style. Join us and experience the benefits of our comprehensive lecture services.
                    </p>
                    <div className='flex  gap-[10px]  justify-between mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base w-[95%] md:w-[100%] '>
                        Our private lectures offer personalized attention, allowing students to receive tailored instruction and support that addresses their unique learning needs and goals.
                        </p>
                    </div>
                    <div className='flex  gap-[10px]  justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%] md:w-[100%] '>
                        In our classroom lectures, students benefit from collaborative learning experiences, where they can engage with peers, share ideas, and learn from each other's perspectives.
                        </p>
                    </div>
                   
                    <p className='text-[#625F5F] text-base font-normal leading-[25px]'>
                    Whether opting for private or classroom lectures, expect personalized attention, collaborative learning, and flexible options tailored to your needs. Embark on your educational journey with us and unlock your full potential today.
                    </p>
                </div>
                <div className={study === true ? "block w-full" : "hidden"}>
                    <img src={ser5} alt="edu" className='w-full object-cover h-[440px] md:h-[254px]' />
                    <h2 className='text-[#3F3C3C] font-semibold text-[30px] my-8'>Study Abroad Package</h2>
                    <p className='text-[#625F5F] text-base font-normal mb-4 leading-[25px]'>
                    At Quest-Inspire, we recognize both the opportunities and complexities of studying abroad. That's why we offer meticulously crafted study abroad packages tailored to your academic goals. Our comprehensive services include exam registrations, coaching, school selection, academic advising, program selection, and cultural orientation. With personalized support from our experienced team, you can navigate the challenges of studying abroad seamlessly, ensuring a smooth transition and an enriching academic journey overseas. Embark on an enriching international academic journey with Quest-Inspire's inclusive study abroad packages."
                    </p>
                    <div className='flex gap-[10px] justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%] md:w-[100%] '>
                        We provide a comprehensive approach, addressing all aspects of the experience from exam registrations to cultural orientation. This ensures full preparation for your academic journey.
                        </p>
                    </div>
                    <div className='flex gap-[10px] justify-between mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base w-[95%] md:w-[100%] '>
                        you'll receive individualized assistance tailored to your specific needs and preferences, helping you make informed decisions and navigate the study abroad process.
                        </p>
                    </div>
                    <div className='flex gap-[10px] justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%] md:w-[100%] '>
                        Experience a seamless transition to studying abroad with our comprehensive packages and dedicated support.
                        </p>
                    </div>
                    
                   
                    <p className='text-[#625F5F] text-base font-normal leading-[25px]'>
                    At Quest-Inspire, we believe that studying abroad is a profound journey of personal growth, cultural immersion, and expanding horizons—not merely about earning academic credits. Our mission is to facilitate your enriching international academic experience, shaping your future and broadening your perspective.
                    </p>
                </div>
                <div className={foreign === true ? "block w-full" : "hidden"}>
                    <img src={ser6} alt="edu" className='w-full object-cover h-[440px] md:h-[254px]' />
                    <h2 className='text-[#3F3C3C] font-semibold text-[30px] my-8'>Quest Tech Empowerment</h2>
                    <p className='text-[#625F5F] text-base font-normal mb-4 leading-[25px]'>
                    In today's rapidly evolving digital landscape, acquiring tech skills has become essential for success. At Quest Tech Empowerment, we're committed to empowering students with the knowledge and expertise needed to thrive in the digital age. Through our comprehensive tech programs, we offer an array of courses designed to equip students with in-demand skills and prepare them for rewarding careers in the tech industry. Below are some of our courses:
                    </p>
                    <div className='flex gap-[10px] justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%] md:w-[100%] '>
                        Web Design and Development: Learn how to create visually appealing and functional websites using the latest tools and technologies.
                        </p>
                    </div>
                    <div className='flex gap-[10px] justify-between mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base w-[95%] md:w-[100%] '>
                        Python Programming: Master Python, a versatile programming language, and its applications in web development to build dynamic websites and web applications.
                        </p>
                    </div>
                    <div className='flex gap-[10px] justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%] md:w-[100%] '>
                        Cybersecurity: Learn how to protect digital assets and systems from cyber threats through courses covering network security, cryptography, ethical hacking, and more.
                        </p>
                    </div>
                    <div className='flex gap-[10px] justify-between  mb-4'>
                        <RiCheckboxCircleLine color='#5146AE' className='w-[25px] h-[25px]' />
                        <p className='text-[#3A3939] font-normal text-base  w-[95%] md:w-[100%] '>
                        Data Analysis: Gain expertise in data analysis techniques, including data visualization, statistical analysis, and machine learning, to extract insights and make informed decisions.
                        </p>
                    </div>
                    
                   
                    <p className='text-[#625F5F] text-base font-normal leading-[25px]'>
                    Our industry-led programs offer hands-on projects and real-world applications for practical learning. Whether you're starting a tech career or enhancing skills, we provide the foundation for success in today's digital world. Join us for an empowering journey in technology.
                    </p>
                </div>
            </div>
        </section>
    </section>
  )
}

export default ServiceBody